/* eslint-disable no-irregular-whitespace */
module.exports = function getResource(label, vars = []) {
    const resources = {
        frequentlyBoughtTogether: 'Produits fréquemment achetés ensemble',
        addAllToBasket: 'Tout ajouter au panier',
        itemsAdded: '3 éléments ajoutés: ',
        totalPrice: `Prix ​​total: $${vars[0]}`
    };

    return resources[label];
};
